import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const COUNTRIES = gql`
  query Countries($filter: CitiesStatesFilter, $sort: CitiesStatesSort) {
    countries(filter: $filter, sort: $sort) {
      count
      data {
        name
        id
      }
    }
  }
`;

export const STATES = gql`
  query States(
    $where: CountryUniqueInput!
    $filter: CitiesStatesFilter
    $sort: CitiesStatesSort
  ) {
    states(where: $where, filter: $filter, sort: $sort) {
      data {
        name
        id
      }
    }
  }
`;

export const CITIES = gql`
  query Cities(
    $where: StateUniqueInput
    $filter: CitiesFilter
    $sort: CitiesStatesSort
  ) {
    cities(where: $where, filter: $filter, sort: $sort) {
      data {
        id
        name
      }
    }
  }
`;

export const PINCODES = gql`
  query Pincodes($filter: PincodesFilter, $sort: PincodesSort) {
    pincodes(filter: $filter, sort: $sort) {
      data {
        id
        pincode
      }
    }
  }
`;

export const FULFILMENT_POSSIBILITY_ORDERS_VIEW = gql`
  query FulfilmentPossibilityOrdersView(
    $filter: fulfilmentPossibilityOrdersFilter
    $sort: FulfilmentPossibilityOrdersViewSort
  ) {
    fulfilmentPossibilityOrdersView(filter: $filter, sort: $sort) {
      count
      data {
        returnItemId
        returnOrderNumber
        orderId
        expectedDeliveryDate
        orderPlacedDate
        orderNumber
        userId
        userName
        currentStatus
        returnOrderItemCreatedAt
        holdingDays
      }
    }
  }
`;

// Library-side variant. Same payload/values; aliased to
// `fulfilmentPossibilityOrdersView` so consumers' response handling is identical.
export const FULFILMENT_POSSIBILITY_ORDERS_VIEW_LIBRARY = gql`
  query FulfilmentPossibilityOrdersViewLibrary(
    $filter: fulfilmentPossibilityOrdersFilter
    $sort: FulfilmentPossibilityOrdersViewSort
  ) {
    fulfilmentPossibilityOrdersView: fulfilmentPossibilityOrdersViewLibrary(
      filter: $filter
      sort: $sort
    ) {
      count
      data {
        returnItemId
        returnOrderNumber
        orderId
        expectedDeliveryDate
        orderPlacedDate
        orderNumber
        userId
        userName
        currentStatus
        returnOrderItemCreatedAt
        holdingDays
      }
    }
  }
`;
